import LocationInput from './component';
import { LocationInputProps } from './types';

export default LocationInput;
export type { LocationInputProps };
